import React from 'react';

interface IEvePriceCalculatorButtonProps {
    label: string;
    buttonName: string;
    isDisabled: boolean;
    onClick: () => void;
}

export const EvePriceCalculatorButton: React.FC<IEvePriceCalculatorButtonProps> = props => {
    const { label, buttonName, isDisabled, onClick } = props;
    const className = `eve-price-calculator-display__form-row-button-${buttonName}`;

    return (
        <div className={`${className}`}>
            <button className={`${className}--button`} disabled={isDisabled} onClick={onClick}>
                {label}
            </button>
        </div>
    );
};
